import { gql } from "apollo-angular";
import { DISCLAIMER_ITEM_FIELDS } from "./disclaimer-item"

export const START_DATES_FIELDS = gql`
  fragment START_DATES_FIELDS on StartDates {
    title
    topDivider
    header
    headerTag
    hTagId
    alignment
    backgroundColor 
    programId
    showTerm
    startDateSelection
    startDateItemsCollection {
      items {
        ...on StartDateItems {
            calendarDate
            startDateDescriptor
            applyByDate
        }
      }
    }
    introCopy {
      json
    }
    disclaimer {
      ... DISCLAIMER_ITEM_FIELDS
    }
  }
${DISCLAIMER_ITEM_FIELDS}`;
